module.exports = " <div class=block> <div class=block__header> <h2 class=block__title>{{searchResults.IntroTitle}}</h2> <ul class=introduction-nav> </ul> </div> <div class=block__content> <div class=introduction> {{{searchResults.IntroParagraph}}} <ul v-if=searchResults.IntroBullets> <li v-for=\"bullet in searchResults.IntroBullets\">{{bullet}}</li> </ul> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/search/SearchIntro.vue
// module id = 207
// module chunks = 0